import React from 'react'
import ReactDOM from 'react-dom/client'
import AppMapper from './AppMapper'
import './twpreflightscoped.min.css'
import './index.css'
import '@sbab-ui/components/style.css'
import ErrorBoundary from './components/ErrorBoundary'

if (process.env.NODE_ENV !== 'production') {
  import('./dev')
}

ReactDOM.createRoot(document.getElementById('savings-calculator-app-root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppMapper />
    </ErrorBoundary>
  </React.StrictMode>,
)
